export enum Marketplace {
    Wb = 'wb',
    Ozon = 'ozon',
    YandexMarket = 'yandexmarket',
}
